/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whitespace Cleaner`)
};

const es_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiador de Espacios en Blanco`)
};

const de_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerzeichen-Bereiniger`)
};

const nl_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witruimte Opruimer`)
};

const fr_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettoyeur d'espaces blancs`)
};

const it_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulitore di Spazi Bianchi`)
};

const pt_br2_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpador de Espaços em Branco`)
};

const pt_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpador de Espaços em Branco`)
};

const ja_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホワイトスペースクリーナー`)
};

const zh_wsc_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白字符清理工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_nav_main = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_nav_main(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_nav_main", locale)
	if (locale === "en") return en_wsc_nav_main(inputs)
	if (locale === "es") return es_wsc_nav_main(inputs)
	if (locale === "de") return de_wsc_nav_main(inputs)
	if (locale === "nl") return nl_wsc_nav_main(inputs)
	if (locale === "fr") return fr_wsc_nav_main(inputs)
	if (locale === "it") return it_wsc_nav_main(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_nav_main(inputs)
	if (locale === "pt") return pt_wsc_nav_main(inputs)
	if (locale === "ja") return ja_wsc_nav_main(inputs)
	return zh_wsc_nav_main(inputs)
};